import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login/Login'
import Catalogos from '@/views/Catalogos/Catalogos'
import Revistas from '@/views/Revistas/Revistas'
import Config from '@/views/Config/Config'
import Logo from '@/views/Config/Logo'
import Rodape from '@/views/Config/Rodape'
import Footer from '@/views/Config/Footer'
import ConfigAvancado from '@/views/Config/Avancado/Avancado'
import Categorias from '@/views/Categorias/Categorias'
import Sync from '@/views/Sync/Sync'
import Marcas from '@/views/Marcas/Marcas'
import Propaganda from '@/views/Propaganda/Propaganda'
import PropagandaBg from '@/views/Propaganda/Bg'
import Slogan from '@/views/Slogan/Slogan'
import SloganBanners from '@/views/Slogan/Banners'
import Comunicados from '@/views/Comunicados/Comunicados'
import LinksMenu from '@/views/Links/Menu'
import LinksCabecalho from '@/views/Links/Cabecalho'
import LinksRodape from '@/views/Links/Rodape'
import Noticias from '@/views/Noticias/Noticias'
import NoticiaSingle from '@/views/Noticias/NoticiaSingle'
import Paginas from '@/views/Paginas/Paginas'
import PaginaSingle from '@/views/Paginas/PaginaSingle'
import ContatosExternos from '@/views/ContatosExternos/ContatosExternos'
import SecoesRodape from '@/views/SecoesRodape/SecoesRodape'
import TrabalheConosco from '@/views/TrabalheConosco/TrabalheConosco'
import Vitrines from '@/views/Vitrines/Vitrines'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'config',
      component: Config
    },
    {
      path: '/rodape',
      name: 'rodape',
      component: Rodape
    },
    {
      path: '/footer',
      name: 'footer',
      component: Footer
    },
    {
      path: '/avancado',
      name: 'avancado',
      component: ConfigAvancado
    },
    {
      path: '/logo',
      name: 'logo',
      component: Logo
    },
    {
      path: '/catalogos',
      name: 'catalogos',
      component: Catalogos
    },
    {
      path: '/revistas',
      name: 'revistas',
      component: Revistas
    },
    {
      path: '/contatos-externos',
      name: 'contatosExternos',
      component: ContatosExternos
    },
    {
      path: '/categorias',
      name: 'categorias',
      component: Categorias
    },
    {
      path: '/marcas',
      name: 'marcas',
      component: Marcas
    },
    {
      path: '/propaganda',
      name: 'propaganda',
      component: Propaganda
    },
    {
      path: '/propaganda/bg',
      name: 'propagandabg',
      component: PropagandaBg
    },
    {
      path: '/slogan',
      name: 'slogan',
      component: Slogan
    },
    {
      path: '/sync',
      name: 'sync',
      component: Sync
    },
    {
      path: '/slogan/banners',
      name: 'sloganbanners',
      component: SloganBanners
    },
    {
      path: '/comunicados',
      name: 'comunicados',
      component: Comunicados
    },
    {
      path: '/links',
      name: 'links',
      component: LinksCabecalho
    },
    {
      path: '/links/rodape',
      name: 'linksrodape',
      component: LinksRodape
    },
    {
      path: '/secoes-rodape',
      name: 'secoesRodape',
      component: SecoesRodape
    },
    {
      path: '/noticias',
      name: 'noticias',
      component: Noticias
    },
    {
      path: '/noticia/:id',
      name: 'noticia',
      component: NoticiaSingle
    },
    {
      path: '/paginas',
      name: 'paginas',
      component: Paginas
    },
    {
      path: '/pagina/:id',
      name: 'pagina',
      component: PaginaSingle
    },
    {
      path: '/trabalhe-conosco',
      name: 'trabalheConosco',
      component: TrabalheConosco
    },
    {
      path: '/vitrines',
      name: 'vitrines',
      component: Vitrines
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js